import ReviewApprovalTable from "./components/ReviewApprovalTable";

const Tables = () => {
  return (
    <div>
      <div className="f mt-5 h-full w-full">
        <ReviewApprovalTable />
      </div>
    </div>
  );
};

export default Tables;
